export const transparencia_item = [
    {
        "transparencia_item_nombre" : "Art. 69 Ley de Transparencia",
        "transparencia_item_url" : "Rubros",
        "opcion" : "1"
    },
    {
        "transparencia_item_nombre" : "Art. 70 Ley de Transparencia",
        "transparencia_item_url" : "Art70"
    },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios (PAAAS)",
        "transparencia_item_url" : "../Paaas"
    },
    {
        "transparencia_item_nombre" : "Matriz de Indicadores para Resultados (MIR)",
        "transparencia_item_url" : "../MIR"
    },
    {
        "transparencia_item_nombre" : "Informes Trimestrales de los Recursos Federales recibidos por esta Secretaría",
        "transparencia_item_url" : "../RecursosFederales"
    },
    // {
    //     "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico (PADA) 2024",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PADA-2024.pdf",
    //     "opcion" : "2" 
    // },
    // {
    //     "transparencia_item_nombre" : "Informe Anual de Cumplimiento del Programa Anual de Desarrollo Archivístico (PADA) 2023",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/InformePADA-2023.pdf",
    //     "opcion" : "2" 
    // },
    // {
    //     "transparencia_item_nombre" : "Programa Anual de Mejora Regulatoria (PAMR) 2023",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PAMR2023.PDF",
    //     "opcion" : "2" 
    // },
    {
        "transparencia_item_nombre" : "Código de Conducta",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CodigoDeConducta.pdf",
        "opcion" : "2" 
    },
    // {
    //     "transparencia_item_nombre" : "Programas Sectoriales Concurrentes 2020 - 2022",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/sectoriales.rar",
    //     "opcion" : "2" 
    // },
    // {
    //     "transparencia_item_nombre" : "Reglas de Operación del Programa 'Construye Tu Camino'",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/ROPCTC2023.pdf",
    //     "opcion" : "2" 
    // },
    {
        "transparencia_item_nombre" : "Lineamientos Generales para la Administración, Desarrollo de Personal y Profesionalización del Servicio Público del Poder Ejecutivo",
        "transparencia_item_url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/LGADPPSPPE.pdf",
        "opcion" : "2"
    }
]